import { render, staticRenderFns } from "./QrLayoutBuilder.vue?vue&type=template&id=2851508a&scoped=true"
import script from "./QrLayoutBuilder.vue?vue&type=script&lang=js"
export * from "./QrLayoutBuilder.vue?vue&type=script&lang=js"
import style0 from "./QrLayoutBuilder.vue?vue&type=style&index=0&id=2851508a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2851508a",
  null
  
)

export default component.exports